import {
    getLicense
    , getTraceability
    , postRetractionService
} from '@/services/modules/permisos-sindicales/v2/licenses/service'
import ApiPermisos from '@/services/apiPermisos';
import {
    getLicenses
} from '@/services/modules/permisos-sindicales/v2/licenses/gestor-impuestos/service'

const state = () => ({
    license: {}
    , processing_license: true
    , traceability: { data: [] }
    , processing_traceability: true
    , processingRetraction: false
    , licenses: {
        data: {
            data: []
            , links: {}
            , meta: {}
        }
        , processing: true
    },
    isAvailableTickets: true,
})

const mutations = {
    SET_LICENSE (state, data = {}) {
        state.license = data
    }
    , SET_PROCESSING_LICENSE (state, value = true) {
        state.processing_license = value
    }
    , SET_TRACEABILITY (state, values = {}) {
        state.traceability = values
    }
    , SET_PROCESSING_TRACEABILITY (state, value = true) {
        state.processing_traceability = value
    }
    , SET_PROCESSING_RETRACTION (state, value = true) {
        state.processingRetraction = value
    }
    , SET_LICENSES (state, data = []) {
        state.licenses.data = data
    }
    , SET_PROCESSING_LICENSES (state, value = true) {
        state.licenses.processing = value
    },
    SET_IS_AVAILABLE_TICKETS(state, value = true) {
        state.isAvailableTickets = value
    }
}

const actions = {
    async getLicenseAction ({ commit }, { id = 0, dataAvailableTickets }) {
        commit('SET_PROCESSING_LICENSE', true)
        try {
            const { result } = await getLicense(id);

            const dataSend = {
                ...dataAvailableTickets,
                type: result?.license_employees[0]?.ticket?.type,
                labor_union_id: result?.laborUnion_id
            }

            const { result: { available }} = await ApiPermisos.limitRequestValidation(dataSend);

            commit('SET_IS_AVAILABLE_TICKETS', available)
            commit('SET_LICENSE', result)
        } catch (error) {
             console.log(error)
        } finally {
            commit('SET_PROCESSING_LICENSE', false)
        }
    }

    , async getTraceabilityAction ({ commit }, { id = 0, data = { } }) {
        commit('SET_PROCESSING_TRACEABILITY')
        const { result } = await getTraceability(id, data).finally(() => commit('SET_PROCESSING_TRACEABILITY', false))
        commit('SET_TRACEABILITY', result)
    }
    , async postRetractionAction ({ commit }, { id = 0 , data = {} }) {
        commit('SET_PROCESSING_RETRACTION')
        return await postRetractionService(id, data).finally(() => commit('SET_PROCESSING_RETRACTION', false))
    }
    , async getLicensesActions ({ commit }, { role = '', data = {} }) {
        const roles = {
            'gestor-impuestos': getLicenses,
            'relaciones-laborales': getLicenses
        }
        if (roles[role])  {
            commit('SET_PROCESSING_LICENSES')
            const { result } =  await roles[role]({ data }).finally(() => commit('SET_PROCESSING_LICENSES', false))
            commit('SET_LICENSES', result)
        }
    }
}

const getters = {
    getLicenseGetter: (state) => state.license
    , getProcessingLicense: (state) => state.processing_license
    , traceabilityGetter: (state) => state.traceability
    , processingTraceabilityGetter: (state) => state.processing_traceability
    , getProcessingRetraction: (state) => state.processingRetraction
    , getLicensesGetter: (state) => state.licenses,
    getIsAvailableTickets: (state) => state.isAvailableTickets
}

export default {
    namespaced: true
    , state
    , getters
    , mutations
    , actions
}